export const authState = 'auth-state';
